import { render, staticRenderFns } from "./ReportMenuVersion.vue?vue&type=template&id=2a7a0d32&"
import script from "./ReportMenuVersion.vue?vue&type=script&lang=js&"
export * from "./ReportMenuVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7a0d32')) {
      api.createRecord('2a7a0d32', component.options)
    } else {
      api.reload('2a7a0d32', component.options)
    }
    module.hot.accept("./ReportMenuVersion.vue?vue&type=template&id=2a7a0d32&", function () {
      api.rerender('2a7a0d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportMenu/ReportMenuVersion/ReportMenuVersion.vue"
export default component.exports